export const GET_USER_DATA = 'GET_USER_DATA';
export const SET_NOTIFICATION_DATA = 'GET_USER_DATA';
export const SET_LOADER_SCREEN = 'SET_LOADER_SCREEN';
